import(/* webpackMode: "eager" */ "/home/jetrails/ca.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/ca.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/ca.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/Footer/footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/Header/announcementsList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/Header/header-client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/HomeCategory/homecategory.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/HomePage/featured-on.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/HomePage/topCarousel.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/ca.awbridal.com/html/src/components/hover-prefetch-link.tsx");
;
import(/* webpackMode: "eager" */ "/home/jetrails/ca.awbridal.com/html/src/components/href-lang-links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/no-ssr.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/products-slider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/ca.awbridal.com/html/src/components/shop-by-colors-family.tsx");
